<template>
<li class="py-10 px-6 bg-gray-100 text-center rounded-lg">
  <div class="space-y-8 flex flex-col h-full">

    <img v-if="!uploaded" class="mx-auto h-24 w-24" :src="iconSrc" alt="">
    <CheckCircleIcon v-else class="mx-auto w-24 h-24 text-green-600" />


    <div class="space-y-3 flex-1 flex flex-col justify-between items-center">
      <div class="font-medium text-lg leading-6 space-y-1">
        <h3 class="text-gray-700">
          <slot name="title" />
        </h3>
        <p class="text-gray-500 text-sm font-normal">
          <slot name="description" />
        </p>
      </div>

      <TailwindButton 
        v-if="!uploaded" 
        :loading="uploading"
        :disabled="uploading"
        @click="$refs.fileInput.click()"
      >
        Upload…
      </TailwindButton>
      <TailwindButton
        v-else-if="!uploading && uploaded"
        @click="remove"
        color="red"
      >
        Remove
      </TailwindButton>

      <input 
        ref="fileInput"
        type="file" 
        class="hidden" 
        @change="fileChanged"
      />
      
      <p v-if="showValidationMessage" class="text-red-600 font-medium">
        Please upload a file.
      </p>

    </div>
  </div>
</li>
</template>

<script>
import TailwindButton from '../TailwindButton.vue'
import { CheckCircleIcon } from '@vue-hero-icons/outline'

import DbsService from '@/services/DbsServices.js'
const dbsService = new DbsService()

export default {
  components: { TailwindButton, CheckCircleIcon, },
  props: {
    iconSrc: String,
    docType: String,
    showValidationMessage: Boolean,
  },
  data() {
    return {
      uploading: false,
      uploaded: false,
    }
  },
  methods: {
    async fileChanged($event) {
      const file = $event.target.files[0]
      if (!file) return

      let response

      try {
        this.uploading = true
        response = await dbsService.uploadDocument(this.docType, file)
      } finally {
        this.uploading = false
      }

      this.$emit('uploaded', response.data /*filename*/)
      this.uploaded = true
    },
    remove() {
      this.uploaded = false
      this.$emit('remove')
    }
  }
}
</script>

<style>

</style>